import { AIThinking } from '@askable/ui/icons';
import { FileText, Library, Package } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'src/lib/routing';
import { useAIQueryAccess } from 'src/hooks/useAIQueryAccess';
import { useProductAccess } from 'src/hooks/useProductAccess';

import { CreateStudy } from './CreateStudy';
import { MenuItem } from './MenuItem';
import { Notifications } from './Notifications/Notifications';

type NavigationProps = {
  isCollapsed: boolean;
  teamId: string;
};

export const Navigation = ({ isCollapsed, teamId }: NavigationProps) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { pathname } = location;
  const { isActionAllowed } = useProductAccess();
  const queryAccess = useAIQueryAccess();

  return (
    // mt-2 puts the first row's centre on the search input's, which sits a little
    // lower than the header it follows.
    <nav className="mt-2">
      <ul className="flex flex-col gap-0.5 px-3">
        {isActionAllowed('create_study') ? (
          <li key="create-study">
            <CreateStudy isCollapsed={isCollapsed} />
          </li>
        ) : null}
        {queryAccess && isActionAllowed('view_ai_chat') ? (
          <li key="chat">
            <MenuItem
              label={t('sections.navigation.askAI')}
              href="/chat"
              icon={AIThinking}
              isActive={pathname === '/chat'}
              isCollapsed={isCollapsed}
            />
          </li>
        ) : null}

        {isActionAllowed('view_notifications') ? (
          <li key="notifications">
            <Notifications teamId={teamId} isCollapsed={isCollapsed} />
          </li>
        ) : null}
        {isActionAllowed('view_studies') ? (
          <li key="studies">
            <MenuItem
              label={t('sections.navigation.studies')}
              href="/studies"
              icon={Library}
              isActive={pathname === '/studies'}
              isCollapsed={isCollapsed}
            />
          </li>
        ) : null}
        {isActionAllowed('view_askable_plus') ? (
          <li key="askable-plus">
            <MenuItem
              label={t('sections.navigation.projectDelivery')}
              href="/askable-plus"
              icon={Package}
              isActive={pathname === '/askable-plus'}
              isCollapsed={isCollapsed}
            />
          </li>
        ) : null}
        {queryAccess && isActionAllowed('view_docs') ? (
          <li key="docs">
            <MenuItem
              label={t('sections.navigation.docs')}
              href="/docs"
              icon={FileText}
              isActive={pathname.startsWith('/docs')}
              isCollapsed={isCollapsed}
            />
          </li>
        ) : null}
      </ul>
    </nav>
  );
};
